module.exports = __webpack_public_path__ + "static/media/Atul-Satija.24267a04.jpg";